import { AbstractControl, ValidatorFn, ValidationErrors, FormArray, FormControl, FormGroup } from "@angular/forms";

export class CheckboxListValidators {
	static atleastOneCheckboxChecked(): ValidatorFn {
		return (formArray : any) : ValidationErrors | null => {
			let valid: boolean = formArray.controls.length ? false : true;
			formArray.controls?.forEach((control: AbstractControl, i: number, arr: any) => {
				if ((<FormControl>control).value) {
					valid = true;
					return;
				}				
			});

			return valid ? null : { error: "Select atleast one checkbox" };
		}
	}

	static atleastOneCheckboxCheckedInFormGroup(propName : string): ValidatorFn {
		return (formArray : any) : ValidationErrors | null => {
			let valid: boolean = formArray.controls.length ? false : true;
			formArray.controls?.forEach((control: AbstractControl, i: number, arr: any) => {
				if( control instanceof FormGroup)
				{
					const grp = control as FormGroup;	
					const subControls = (<FormGroup>grp)?.controls;

					(<FormArray>subControls?.[propName])?.controls?.forEach((subControl: AbstractControl, j: number, subArr: any) => {
						if ((<FormControl>subControl).value) 
						{
							valid = true;
							return;
						}				
					});
					if(valid)
					{
						return;
					}					
				}					
			});

			return valid ? null : { error: "Select atleast one checkbox" };
		}
	}
	
}